import { render, staticRenderFns } from "./CreatedFormConfig.vue?vue&type=template&id=434dafaf&"
import script from "./CreatedFormConfig.vue?vue&type=script&lang=js&"
export * from "./CreatedFormConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports